export enum DocumentScanningResultStatus {
  Pending = 'Pending',
  AwaitingResults = 'AwaitingResults',
  Success = 'Success',
  Failure = 'Failure',
}
